export const ORDER_STATUS_CREATED = "CREATED";
export const ORDER_STATUS_PAID = "PAID";
export const ORDER_STATUS_SHIPPED = "SHIPPED";
export const ORDER_STATUS_COMPLETED = "COMPLETED";
export const ORDER_STATUS_RETURNED = "RETURNED";
export const ORDER_STATUS_KLARNA_AUTHORIZED = "KLARNA_AUTHORIZED";
